// Great-circle helpers for the search-radius overlay. A hand-rolled
// destination-point formula keeps Turf (the old map's CDN dependency) out of
// the bundle for what is a few lines of math.

const EARTH_RADIUS_KM = 6371;

const toRadians = (degrees) => (degrees * Math.PI) / 180;
const toDegrees = (radians) => (radians * 180) / Math.PI;

export const circlePolygon = (long, lat, radiusKm, steps = 64) => {
  const angularDistance = radiusKm / EARTH_RADIUS_KM;
  const latRad = toRadians(lat);
  const longRad = toRadians(long);

  const coordinates = [];
  for (let step = 0; step <= steps; step += 1) {
    const bearing = (2 * Math.PI * step) / steps;
    const pointLat = Math.asin(
      Math.sin(latRad) * Math.cos(angularDistance) +
        Math.cos(latRad) * Math.sin(angularDistance) * Math.cos(bearing)
    );
    const pointLong =
      longRad +
      Math.atan2(
        Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(latRad),
        Math.cos(angularDistance) - Math.sin(latRad) * Math.sin(pointLat)
      );
    coordinates.push([toDegrees(pointLong), toDegrees(pointLat)]);
  }

  return { type: 'Polygon', coordinates: [coordinates] };
};

export const circleBounds = (long, lat, radiusKm) => {
  const latDelta = toDegrees(radiusKm / EARTH_RADIUS_KM);
  const longDelta = latDelta / Math.cos(toRadians(lat));

  return [long - longDelta, lat - latDelta, long + longDelta, lat + latDelta];
};
